import React, {useEffect, useState} from "react";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import {
  TableList,
  PickerSearch,
  FormDatePicker,
  Spinner,
} from "../../components";
import CustomizedSnackbars from "../../components/base/Snackbar";
import api from "../../helpers/api";
import {tableHeadStockCard} from "../../utils/Constants";
import DownloadForOfflineIcon from "@mui/icons-material/DownloadForOffline";
import SearchIcon from "@mui/icons-material/Search";
import {exportToXLSX} from "../../helpers/functions/generateExcel";
import moment from "moment";
import ModalDetail from "../../components/ModalDetail";
import {Box, useTheme, useMediaQuery, Paper, IconButton} from "@mui/material";
import FilterListIcon from "@mui/icons-material/FilterList";
import CloseIcon from "@mui/icons-material/Close";

function StockCard() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md"));

  const [isFilterOpen, setIsFilterOpen] = useState(!isMobile);

  const [isLoading, setIsLoading] = useState(false);
  const [isSpinner, setIsSpinner] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [alertType, setAlertType] = useState("");
  const [message, setMessage] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalRecord, setTotalRecord] = useState(0);
  // ==================
  const [orderBy, setOrderBy] = useState("");
  const [order, setOrder] = useState("desc");
  // ==================
  const [stockCardList, setStockCardList] = useState(null);
  // ==================
  const [branchList, setBranchList] = useState([]);
  const [searchBranchName, setSearchBranchName] = useState("");
  const [branchCodeSelected, setBranchCodeSelected] = useState("");
  // ==================
  const [productList, setProductList] = useState(null);
  const [searchProductName, setSearchProductName] = useState("");
  const [productNameSelected, setProductNameSelected] = useState([]);
  // ==================
  const [selectedDateFrom, setSelectedDateFrom] = useState(moment());
  const [selectedDateTo, setSelectedDateTo] = useState(moment());
  const [transactionCode, setTransactionType] = useState(50);
  // ==================
  const [transactionSelected, setTransactionSelected] = useState([]);
  const [detailTransaction, setDetailTransaction] = useState([]);
  const [isVisibleDetail, setIsVisibleDetail] = useState(false);
  // ===============

  const onGetStockCard = async () => {
    setIsLoading(true);
    const currentPage = page + 1;
    const dateFromSelected =
      selectedDateFrom === null
        ? ""
        : moment(selectedDateFrom).format("YYYY-MM-DD");
    const dateToSelected =
      selectedDateTo === null
        ? ""
        : moment(selectedDateTo).format("YYYY-MM-DD");
    try {
      const res = await api
        .getStockCard(
          branchCodeSelected,
          productNameSelected.length !== 0
            ? productNameSelected.productName
            : "",
          dateFromSelected,
          dateToSelected,
          rowsPerPage,
          currentPage
        )
        .then(async (res) => {
          if (res.statusCode === 200) {
            console.log("kartu stok", res.data.data);
            setTotalRecord(res.data.totalPage * res.data.limit);
            setStockCardList(res.data.data);
            setIsLoading(false);
          } else {
            setStockCardList([]);
            onError(res.message);
          }
        })
        .catch((error) => {
          setStockCardList([]);
          onError(error.message);
        });
    } catch (error) {
      setStockCardList([]);
      onError(error.message);
    }
  };

  const onGetBranches = async () => {
    try {
      const res = await api
        .getBranch(searchBranchName)
        .then(async (res) => {
          if (res.statusCode === 200) {
            const newBranch = {
              id: "",
              branchName: "All Branches",
              address: "",
              branchPhone: "",
              statusName: "",
              statusCode: "",
              branchCode: "",
              createdDate: "",
              updatedDate: "",
            };
            const updatedBranchList = [newBranch, ...res.data.data];
            setBranchList(res.data.data);
          } else {
            onError(res.message);
          }
        })
        .catch((error) => {
          onError(error.message);
        });
    } catch (error) {
      onError(error.message);
    }
  };

  const onGetProducts = async () => {
    try {
      const res = await api
        .getProduct(searchProductName, "")
        .then(async (res) => {
          if (res.statusCode === 200) {
            setProductList(res.data.data);
          } else {
            onError(res.message);
            setProductList([]);
          }
        })
        .catch((error) => {
          onError(error.message);
          setProductList([]);
        });
    } catch (error) {
      onError(error.message);
      setProductList([]);
    }
  };

  const onGetDetailTransaction = async (data) => {
    try {
      const res = await api
        .getDetailTransaction(data.id)
        .then(async (res) => {
          if (res.statusCode === 200) {
            setDetailTransaction(res.data);
            setTransactionSelected(data);
            setIsVisibleDetail(true);
          } else {
            onError(res.message);
          }
        })
        .catch((error) => {
          onError(error.message);
        });
    } catch (error) {
      onError(error.message);
    }
  };

  const onHandleReport = async () => {
    setIsSpinner(true);
    const dateFromSelected =
      selectedDateFrom === null
        ? ""
        : moment(selectedDateFrom).format("YYYY-MM-DD");
    const dateToSelected =
      selectedDateTo === null
        ? ""
        : moment(selectedDateTo).format("YYYY-MM-DD");
    try {
      const res = await api
        .reportDownload(transactionCode, dateFromSelected, dateToSelected)
        .then(async (res) => {
          if (res.statusCode === 200) {
            const fileName = "Stock-card-report";
            setIsSpinner(false);
            exportToXLSX(res.data.data, fileName);
            onSuccessSubmit();
          } else {
            onError(res.message);
          }
        })
        .catch((error) => {
          onError(error.message);
        });
    } catch (error) {
      onError(error.message);
    }
  };

  // ==============
  useEffect(() => {
    const fetch = async () => {
      await onGetStockCard();
    };
    fetch();
  }, [page, rowsPerPage]);

  useEffect(() => {
    onGetBranches();
  }, [searchBranchName]);

  useEffect(() => {
    onGetProducts();
  }, [searchProductName]);

  const onError = async (message) => {
    setIsLoading(false);
    setIsSpinner(false);
    setIsOpen(true);
    setAlertType("error");
    setMessage(message);
  };

  const onSuccessSubmit = async () => {
    setIsOpen(true);
    setAlertType("success");
    setMessage("Successfully...");
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const handlePreviewDetail = (itemSelected, indexSelected) => {
    setDetailTransaction(itemSelected);
    setIsVisibleDetail(true);
  };

  const handleRequestSort = (property) => {
    const isAsc = orderBy === property && order === "asc";
    const newOrder = isAsc ? "desc" : "asc";

    const sortedData = [...stockCardList].sort((a, b) => {
      // Use dynamic property access with bracket notation
      const valueA = a[property];
      const valueB = b[property];

      // Handle different types of sorting
      if (typeof valueA === "string") {
        return newOrder === "asc"
          ? valueA.localeCompare(valueB)
          : valueB.localeCompare(valueA);
      }

      return newOrder === "asc" ? valueA - valueB : valueB - valueA;
    });

    setStockCardList(sortedData);
    setOrder(newOrder);
    setOrderBy(property);
  };

  const handleSearch = () => {
    setPage(0);
    onGetStockCard();
    if (isMobile) {
      setIsFilterOpen(false);
    }
  };

  return (
    <>
      <Spinner isShowSpinner={isSpinner} />
      <CustomizedSnackbars
        isOpen={isOpen}
        typeInfo={alertType}
        messageInfo={message}
        handleCloseSnackbar={() => setIsOpen(false)}
      />

      <Paper
        elevation={1}
        sx={{
          width: "100%",
          borderRadius: 1,
          overflow: "hidden",
          mb: 3,
        }}
      >
        {/* Header */}
        <Box
          sx={{
            display: "flex",
            flexDirection: {xs: "column", sm: "row"},
            justifyContent: "space-between",
            alignItems: {xs: "flex-start", sm: "center"},
            p: {xs: 2, sm: 3},
            borderBottom: "1px solid",
            borderColor: "divider",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <Typography
              variant={isMobile ? "subtitle1" : "h6"}
              sx={{
                fontWeight: "medium",
                width: {xs: "80%", sm: "auto"},
              }}
            >
              Stock Card List
            </Typography>

            {isMobile && (
              <IconButton
                color="primary"
                onClick={() => setIsFilterOpen(!isFilterOpen)}
                size="small"
              >
                <FilterListIcon />
              </IconButton>
            )}
          </Box>

          {(!isMobile || !isFilterOpen) && (
            <Button
              variant="outlined"
              color="primary"
              startIcon={<DownloadForOfflineIcon />}
              onClick={onHandleReport}
              size={isMobile ? "small" : "medium"}
              sx={{
                mt: {xs: 2, sm: 0},
                ml: {sm: 2},
                whiteSpace: "nowrap",
                minWidth: {xs: "auto", sm: "160px"},
                px: {xs: 1.5, sm: 2},
                fontSize: {xs: "0.8125rem", sm: "0.875rem"},
              }}
            >
              Download Report
            </Button>
          )}
        </Box>

        {/* Search Section */}
        {(isFilterOpen || !isMobile) && (
          <Box
            sx={{
              p: {xs: 2, sm: 3},
              borderBottom: "1px solid",
              borderColor: "divider",
              position: "relative",
            }}
          >
            {isMobile && (
              <Box sx={{position: "absolute", top: 10, right: 10, zIndex: 5}}>
                <IconButton
                  size="small"
                  onClick={() => setIsFilterOpen(false)}
                  color="default"
                >
                  <CloseIcon fontSize="small" />
                </IconButton>
              </Box>
            )}

            <Grid container spacing={2} alignItems="flex-start">
              {/* First row of form fields */}
              <Grid
                item
                xs={12}
                md={10}
                lg={10}
                sx={{
                  display: "flex",
                  flexDirection: {xs: "column", sm: "row"},
                  flexWrap: "wrap",
                  gap: 2,
                }}
              >
                {/* OUTLET */}
                <Box
                  sx={{
                    width: {
                      xs: "100%",
                      sm: "calc(50% - 8px)",
                      md: "calc(25% - 8px)",
                      lg: "calc(25% - 12px)",
                    },
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <Typography
                    variant="caption"
                    sx={{
                      fontWeight: 600,
                      fontSize: isMobile ? "0.7rem" : "0.75rem",
                      mb: 1,
                    }}
                  >
                    CHOOSE OUTLET
                  </Typography>
                  <PickerSearch
                    dataList={branchList}
                    onInputChange={(event, newInputValue) => {
                      setSearchBranchName(newInputValue);
                    }}
                    onChange={(e, v) => {
                      if (v) {
                        setBranchCodeSelected(v.branchCode);
                      } else {
                        setBranchCodeSelected("");
                      }
                    }}
                    getOptionLabel={(branchList) => branchList.branchName || ""}
                    labelPicker="Choose Outlet"
                    placeholderPicker="search outlet"
                    sizePicker="small"
                    isVisibleLabelPicker={false}
                    sx={{width: "100%"}}
                  />
                </Box>

                {/* PRODUCT */}
                <Box
                  sx={{
                    width: {
                      xs: "100%",
                      sm: "calc(50% - 8px)",
                      md: "calc(25% - 8px)",
                      lg: "calc(25% - 12px)",
                    },
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <Typography
                    variant="caption"
                    sx={{
                      fontWeight: 600,
                      fontSize: isMobile ? "0.7rem" : "0.75rem",
                      mb: 1,
                    }}
                  >
                    CHOOSE PRODUCT
                  </Typography>
                  <PickerSearch
                    dataList={productList}
                    onInputChange={(event, newInputValue) => {
                      setSearchProductName(newInputValue);
                    }}
                    onChange={(e, v) => {
                      if (v) {
                        setProductNameSelected(v);
                      } else {
                        setProductNameSelected([]);
                      }
                    }}
                    getOptionLabel={(product) => product.productName || ""}
                    labelPicker={"Choose Product"}
                    placeholderPicker={"search product"}
                    sizePicker={"small"}
                    isVisibleLabelPicker={false}
                    sx={{width: "100%"}}
                  />
                </Box>

                {/* DATE FROM */}
                <Box
                  sx={{
                    width: {
                      xs: "100%",
                      sm: "calc(50% - 8px)",
                      md: "calc(25% - 8px)",
                      lg: "calc(25% - 12px)",
                    },
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <Typography
                    variant="caption"
                    sx={{
                      fontWeight: 600,
                      fontSize: isMobile ? "0.7rem" : "0.75rem",
                      mb: 1,
                    }}
                  >
                    DATE FROM
                  </Typography>
                  <FormDatePicker
                    labelFormDatePicker="Date From"
                    dateValue={selectedDateFrom}
                    onChangeDate={(val) => setSelectedDateFrom(val)}
                    fullWidth
                  />
                </Box>

                {/* DATE TO */}
                <Box
                  sx={{
                    width: {
                      xs: "100%",
                      sm: "calc(50% - 8px)",
                      md: "calc(25% - 8px)",
                      lg: "calc(25% - 12px)",
                    },
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <Typography
                    variant="caption"
                    sx={{
                      fontWeight: 600,
                      fontSize: isMobile ? "0.7rem" : "0.75rem",
                      mb: 1,
                    }}
                  >
                    DATE TO
                  </Typography>
                  <FormDatePicker
                    labelFormDatePicker="Date To"
                    dateValue={selectedDateTo}
                    onChangeDate={(val) => setSelectedDateTo(val)}
                    fullWidth
                  />
                </Box>
              </Grid>

              {/* Search button column */}
              <Grid
                item
                xs={12}
                md={4}
                lg={2}
                sx={{
                  display: "flex",
                  alignItems: {xs: "flex-start", md: "flex-end"},
                  height: "100%",
                }}
              >
                <Box
                  sx={{
                    flexGrow: 0,
                    width: {
                      xs: "100%",
                      sm: "50%",
                      md: "100%", // Full width on medium screens (second row)
                      lg: "auto",
                      xl: "calc(20% - 16px)",
                    },
                    marginTop: {md: 2, lg: 0}, // Add margin top on medium screens
                    order: {xs: 5, sm: 5, md: 4, lg: 5, xl: 5}, // Change order on medium screens
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "flex-end",
                  }}
                >
                  <Typography
                    variant="caption"
                    sx={{
                      visibility: {
                        xs: "hidden",
                        sm: "hidden",
                        md: "hidden",
                        lg: "visible",
                        xl: "visible",
                      },
                      display: "block",
                      fontWeight: 600,
                      fontSize: "0.75rem",
                      mb: 1,
                      opacity: 0,
                      height: {xs: 0, sm: 0, md: 0, lg: "19px", xl: "19px"},
                    }}
                  >
                    &nbsp;
                  </Typography>
                  <Button
                    variant="contained"
                    color="primary"
                    startIcon={<SearchIcon />}
                    onClick={handleSearch}
                    sx={{
                      height: 40,
                      width: {
                        xs: "100%",
                        sm: "100%",
                        md: "180px",
                        lg: "180px",
                        xl: "100%",
                      },
                      minWidth: {md: "180px"},
                      maxWidth: {sm: "100%", md: "100%"},
                      alignSelf: {xs: "center", sm: "flex-start"},
                    }}
                  >
                    Search
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </Box>
        )}

        {/* Table List */}
        <Box
          sx={{
            overflowX: "auto",
            "& .MuiTableCell-root": {
              whiteSpace: isMobile ? "nowrap" : "normal",
              px: {xs: 1, sm: 2},
              py: {xs: 1, sm: 1.5},
            },
          }}
        >
          <TableList
            tableStructure="stock-card-list"
            tableName="Stock Card"
            orderBy={orderBy}
            order={order}
            isLoading={isLoading}
            isShowPagination={true}
            tableHeadList={tableHeadStockCard}
            data={stockCardList}
            rowsPerPage={rowsPerPage}
            page={page}
            totalRecord={totalRecord}
            handleChangePage={handleChangePage}
            handleChangeRowsPerPage={handleChangeRowsPerPage}
            onPreviewDetail={handlePreviewDetail}
            handleRequestSort={handleRequestSort}
          />
        </Box>
      </Paper>

      <ModalDetail
        type="history-detail"
        fullScreen={true}
        onClose={() => setIsVisibleDetail(false)}
        isVisibleDetail={isVisibleDetail}
        detailProduct={detailTransaction}
      />
    </>
  );
}

export default StockCard;
